/**
 * Comprime una imagen usando Canvas antes de subir a Firebase Storage.
 * @param {File} file - Archivo original
 * @param {number} maxWidth - Ancho máximo en px (default 1080)
 * @param {number} quality - Calidad JPEG 0-1 (default 0.75)
 * @returns {Promise<Blob>} - Blob comprimido
 */
export const compressImage = (file, maxWidth = 1080, quality = 0.75) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
            const scale = Math.min(1, maxWidth / img.width);
            const canvas = document.createElement('canvas');
            canvas.width  = img.width  * scale;
            canvas.height = img.height * scale;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            URL.revokeObjectURL(url);
            canvas.toBlob(
                blob => blob ? resolve(blob) : reject(new Error('Error comprimiendo imagen')),
                'image/jpeg',
                quality
            );
        };
        img.onerror = reject;
        img.src = url;
    });
};